export default function useGoogleConnectorAccess() {
  return true
}
